import React, { useState, useEffect, useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { preloadVideosSequentially } from './videoDB';

const CircularDownloadProgress = ({
  videoList,
  airtableVideoList,
  brandColor,
  videoDownloaded,
}) => {
  const [downloadProgress, setDownloadProgress] = useState(0);

  console.log("videoList", videoList);

  console.log("download progress", downloadProgress)

  useEffect(() => {
    console.log('airtableVideoList', airtableVideoList);
    if (airtableVideoList.length > 0) {
      videoList.push(...airtableVideoList);
    }

    preloadVideosSequentially(videoList, overallProgress => {
      const newProgress = Math.floor(overallProgress * 100);
      if (newProgress === 100) {
        videoDownloaded(true);
      }

      // Only update if the new progress is greater than current progress
      setDownloadProgress(prevProgress => {
        return newProgress > prevProgress ? newProgress : prevProgress;
      });
      // Update progress bar here
    }).then(results => {
      console.log('All videos done:', results);
    });
  }, [videoList, airtableVideoList]);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        width: 150,
        height: 150,
        display: downloadProgress < 100 ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.paper',
        borderRadius: '50%',
        boxShadow: 3,
      }}
    >
      <Box position="relative" display="inline-flex">
        <CircularProgress
          variant="determinate"
          value={downloadProgress}
          size={140}
          thickness={5}
          sx={{
            color: brandColor, // change to your color
          }}
        />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography
            variant="caption"
            component="div"
            color="text.secondary"
            sx={{ fontSize: '24px', color: brandColor, fontWeight: 'bold' }} // You can use px, rem, or theme values
          >
            {`${Math.round(downloadProgress)}%`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CircularDownloadProgress;
